import { TranslateService } from "@ngx-translate/core";

import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnChanges, computed, inject, input, resource } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";

import { DEFAULT_LANGUAGE } from "../../../../constants";
import { GetNewsItemLink, NewsItem } from "../../../domain/schemas/news-item";

@Component({
  selector: "news-item",
  templateUrl: "./news-item.component.html",
  styleUrl: "./news-item.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterModule, GetNewsItemLink],
})
export class NewsItemComponent implements OnChanges {
  private title = inject(Title);
  private translate = inject(TranslateService);

  item = input.required<NewsItem>();
  summary = input.required<boolean>();
  setBrowserTitle = input(false);

  protected currentLang = computed(() => this.translate.currentLang() ?? DEFAULT_LANGUAGE);

  protected categories = computed(() => {
    const originals = this.item().categories;
    return originals.filter((c) => c !== "Uncategorized");
  });
  protected description = computed(() => this.item().description);
  protected contentEncoded = computed(() => this.item().contents);
  protected creator = computed(() => this.item().author);
  protected showCreator = computed(
    () => this.creator() !== null && this.creator() !== undefined && this.creator()?.trim() !== "",
  );

  protected firstImageUrl = computed(() => this._firstImageUrl.value() ?? "");
  protected _firstImageUrl = resource({
    params: () => ({ contentEncoded: this.contentEncoded() }),
    loader: ({ params }) => this.getFirstImageUrl(params.contentEncoded),
  });

  ngOnChanges() {
    if (this.setBrowserTitle()) this.ngOnChangesAsync();
  }

  private async ngOnChangesAsync() {
    this.title.setTitle(this.item().title);
  }

  private async getFirstImageUrl(content: string): Promise<string> {
    const re = /<img[^>]*src="([^"]+)"[^>]*>/;
    const findings = re.exec(content);
    return findings?.[0] ?? "";
  }
}
